// import { IntlActions } from 'react-redux-multilingual';
import constants from './UserConstants';

export const showLoginModal = () => {
    return { type: constants.SHOW_LOGIN_MODAL };
};

export const closeLoginModal = () => {
    return { type: constants.CLOSE_LOGIN_MODAL };
};

export const showRegisterModal = () => {
    return { type: constants.SHOW_REGISTER_MODAL };
};

export const closeRegisterModal = () => {
    return { type: constants.CLOSE_REGISTER_MODAL };
};

export const setTokenInformation = ({ token, refreshToken, tokenExpiration, valid }) => {
    return { type: constants.SET_TOKEN_INFORMATION, payload: { token, refreshToken, tokenExpiration, valid } };
};

export const setUserInformation = ({ email, username, name }) => {
    return { type: constants.SET_USER_INFORMATION, payload: { email, username, name } };
};

export const clearUserInformationCreator = () => {
    return { type: constants.CLEAR_USER_INFORMATION };
};

export const clearTokenInformationCreator = () => {
    return { type: constants.CLEAR_TOKEN_INFORMATION };
};

export const logoutUserCreator = () => {
    return (dispatch) => {
        localStorage.clear();
        dispatch(clearTokenInformationCreator());
        dispatch(clearUserInformationCreator());
    };
};



// WEBPACK FOOTER //
// ./src/reducers/UserReducer/UserActions.js